import { slotConstants } from './slotConstants';
import {userConstants} from "../../auth/_redux/authConstants";

const makeInitialState = () => ({
  requestActive: false,
  requestSaveActive: false,
  shouldReload: true,
  items: [],
  rowsPerPage: 10,
  page: 1,
  startDate: null,
  endDate: null,
  timeRange: null,
  sortBy: "id",
  sortDirection: "desc",
  error: '',
  query: "",
  inProgress: true,
});

export function slots(state = makeInitialState(), action) {
  switch (action.type) {
    case userConstants.LOGOUT:
      return makeInitialState();
    case slotConstants.SLOT_LIST_REQUEST:
      return {
        ...state,
        items: [],
        requestActive: true,
        shouldReload: false,
        error: '',
        total: 0,
        inProgress: true,
      };
    case slotConstants.SLOT_LIST_SUCCESS:
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        items: action.slots.rows ? action.slots.rows : [],
        total: action.slots.total ? action.slots.total : 0,
        inProgress: false,
      };
    case slotConstants.SLOT_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        inProgress: false,
      };
    case slotConstants.SLOT_LIST_CHANGED:
      return {
        ...state,
        shouldReload: true,
      };
    case slotConstants.SLOT_LIST_PAGINATION: {
      let shouldReload = state.items.length === 0 ? true : false;

      if (state.rowsPerPage !== action.pagination.rowsPerPage
        || state.page !== action.pagination.page
        || (action.pagination.startDate && action.pagination.endDate)
        || state.sortBy !== action.pagination.sortBy
        || state.sortDirection !== action.pagination.sortDirection
        || state.query !== action.pagination.query
        || state.exactFields !== action.pagination.exactFields
        || state.exactValues !== action.pagination.exactValues
        || state.shouldReload) {
        shouldReload = true;
      }

      return {
        ...state,
        rowsPerPage: action.pagination.rowsPerPage,
        page: action.pagination.page,
        startDate: action.pagination.startDate,
        endDate: action.pagination.endDate,
        timeRange: action.pagination.timeRange ? action.pagination.timeRange : state.timeRange,
        sortBy: action.pagination.sortBy,
        sortDirection: action.pagination.sortDirection,
        query: action.pagination.query,
        exactFields: action.pagination.exactFields,
        exactValues: action.pagination.exactValues,
        shouldReload
      };
    }

    case slotConstants.SLOT_SAVE_REQUEST:
      return {
        ...state,
        requestSaveActive: true,
      }
    case slotConstants.SLOT_SAVE_SUCCESS:
      if (action.isNew) {
        return {
          ...state,
          requestSaveActive: false,
          items: [...state.items, action.slot]
        }
      }
      return {
        ...state,
        requestSaveActive: false,
        items: state.items.map(s => s.id === action.slot.id ? action.slot : s)
      }

    case slotConstants.SLOT_SAVE_FAILURE:
      return {
        ...state,
        requestSaveActive: false,
        error: action.error,
      }

    default:
      return state
  }
}
